import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';

const CustomModal = (props) => {
  const {
    className,
    modalClassName,
    isOpen,
    setModelOpen,
    onButtonClicked,
    modalTitle,
    modalMessage,
    primaryButtonText,
    secondaryButonText,
  } = props;

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={() => {
          setModelOpen();
        }}
        className={className}
        modalClassName={modalClassName}
      >
        <ModalBody>
          <h1>{modalTitle}</h1>
          <p>{modalMessage}</p>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              onButtonClicked(false);
            }}
          >
            {secondaryButonText}
          </Button>
          <Button
            color="primary"
            onClick={() => {
              onButtonClicked(true);
            }}
          >
            {primaryButtonText}
          </Button>{' '}
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default CustomModal;
